<template>
    <div class='ProductPricing row'>
        <div class='col-4 CurrentPrice'>
            <span>Current Price:</span>
            <div class='PriceHolder row'>
                <span class='Currency col-1'>$</span>
                <input :id='CurrentPrice' :placeholder='this.propValue' :value='this.currentPrice' @input='custom' class='col-11'>
            </div>
        </div>
        <div class='col-8 PriceAdjust'>
            <div class='row'>
                <MarginCalculator
                    :label='MarginLabel'
                    :value='margin'
                    :store='currentStore'
                />
            </div> 
            <div class='row'>
                <MarginCalculator
                    :label='DiscountLabel'
                    :value='discount'
                    :store='currentStore'
                />
            </div> 
        </div>
    </div>
</template>

<script>
    import MarginCalculator from '../../widget/MarginCalculator/MarginCalculator';
    export default{
        name: 'ProductPricing',
        props: ['price', 'margin', 'discount', 'store'],
        components: {
            MarginCalculator
        },
        data(){
            return{
                MarginLabel: 'Adjusted Margin',
                DiscountLabel: 'Added Discount',
                CurrentPrice: 'Current Price',
                propValue: this.$props.price,
                currentStore: this.$props.store
            }
        },
        computed: {
            currentPrice(){
                return this.$props.price
            }
        },
        methods: {
            custom(e){
                if(parseInt(e.target.value) >= 0){
                    this.propValue = parseInt(e.target.value);
                    let newValue = {
                        type: 'Current Price',
                        value: this.propValue
                    }
                    this.$store.dispatch(this.currentStore + '/calculatePrice', newValue)
                }
            }
        }
    }

</script>